// extracted by mini-css-extract-plugin
module.exports = {"consent":"Consent_consent__2qlMM","consent__text":"Consent_consent__text__33Vtj","consent__link":"Consent_consent__link__38Nsf"};